import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { BrowserFrame, CheckList, DemoCaption } from '../compass/shared';

// Section 10 — contractor management with the Contractor Portal screenshot.
// Approval status never transfers legal responsibility.
export const ForeseeContractors = ({ sp }) => (
  <section aria-labelledby="foresee-contractors-heading" data-testid="foresee-contractors" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="10"
        eyebrow="Contractor Control"
        title="Keep contractor approval and documentation visible"
        description={sp.contractorCopy}
        testid="foresee-contractors-header"
      />
      <div className="mt-12 grid items-start gap-12 lg:grid-cols-5">
        <Reveal className="lg:col-span-3">
          <BrowserFrame shot={sp.shots.contractors} label="Foresee — demonstration workspace" />
          <DemoCaption className="text-left" />
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-2">
          <div className="rounded-xl border border-slate-200 bg-mist p-7">
            <CheckList items={sp.contractorPoints || []} testid="foresee-contractor-points" />
          </div>
          <p className="mt-5 border-l-2 border-indigo-500 pl-4 text-sm font-medium leading-relaxed text-slate-600" data-testid="foresee-contractor-disclaimer">
            Contractor approval remains subject to the organisation's own review process and competent assessment — a platform status does not transfer legal responsibility or independently verify documents.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
